var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendBtn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 70,
    viewBox: "0 0 118 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 69,
    rx: 6.5,
    fill: "#0B8E70"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 69,
    rx: 6.5,
    stroke: "#0B8E70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6596 23.7305V46.8359H43.562V35.2578H41.6069V45.7695H38.5346V39.1426L36.7065 41.5801C34.561 40.4502 33.1772 38.5332 32.3647 36.1465C31.5903 38.8887 30.2192 41.1104 28.0229 42.418L26.0171 39.9297C29.521 37.9492 30.7143 33.8613 30.7143 29.4434V28.707H26.8042V26.1172H37.3921V28.707H33.8628V29.4434C33.8628 33.4678 35.0561 37.3018 38.5346 39.0918V24.0605H41.6069V32.6172H43.562V23.7305H46.6596ZM67.9248 23.7559V40.6152H64.7002V32.3379H60.917V29.7227H64.7002V23.7559H67.9248ZM68.4834 43.8398V46.4297H52.5889V39.1426H55.8389V43.8398H68.4834ZM57.1846 28.2754C57.1846 30.9414 58.8096 33.8105 62.4912 35.0039L60.8916 37.5684C58.3271 36.7432 56.5752 35.0547 55.5596 32.9473C54.5439 35.2832 52.7031 37.1367 49.9736 38.0508L48.3232 35.4102C52.1318 34.2168 53.8584 31.1953 53.8838 28.25V27.8945H49.2373V25.3047H61.7803V27.8945H57.1846V28.2754ZM82.5122 31.9062V34.75H91.4751V37.3398H70.4009V34.75H79.313V31.9062H82.5122ZM82.563 24.873C82.563 27.5645 85.1529 30.1289 90.3579 30.7637L89.1138 33.2773C85.2163 32.6934 82.3472 31.0557 80.8872 28.7324C79.4019 31.0557 76.5327 32.7061 72.6353 33.2773L71.4927 30.7637C76.5962 30.1289 79.2622 27.4883 79.2622 24.873V24.1113H82.563V24.873ZM80.9126 38.6094C85.94 38.6094 88.9361 40.1074 88.9614 42.748C88.9361 45.3887 85.94 46.8359 80.9126 46.8359C75.8345 46.8359 72.813 45.3887 72.813 42.748C72.813 40.1074 75.8345 38.6094 80.9126 38.6094ZM80.9126 41.0723C77.688 41.0723 76.0884 41.6055 76.1138 42.748C76.0884 43.8906 77.688 44.4238 80.9126 44.4238C84.0611 44.4238 85.6861 43.8906 85.7114 42.748C85.6861 41.6055 84.0611 41.0723 80.9126 41.0723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendBtn2);
export default __webpack_public_path__ + "static/media/resendBtn2.0592c743d715f81b62d605d329c399f0.svg";
export { ForwardRef as ReactComponent };